export default __webpack_public_path__ + "static/media/login.28aa17df.jpg";